var path = 'app/scripts/modules/amazon/src/serverGroup/configure/wizard/zones/azRebalanceSelector.component.html';
var html = "<div class=\"form-group\">\n  <div class=\"col-md-3 sm-label-right\"><b>AZ Rebalance</b></div>\n  <div class=\"col-md-7 checkbox\">\n    <label><input type=\"checkbox\"\n                  ng-click=\"$ctrl.command.toggleSuspendedProcess('AZRebalance')\"\n                  ng-checked=\"!$ctrl.command.processIsSuspended('AZRebalance')\"/>\n      Keep instances evenly distributed across zones\n    </label>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/serverGroup/configure/wizard/zones/azRebalanceSelector.component.html
// module id = 1193
// module chunks = 0